module.exports = __webpack_public_path__ + "static/media/moire_revision.684e893b.jpg";